// Purpose: Stock transaction API calls — inout CRUD, productInout, revert, checklist
// Caller: inoutAction, ProductOutPage, ProductInPage
// Dependencies: utils/xhr
// Main Functions: getInouts, createInout, updateInout, deleteInout, productInout, revertProductIn, revertProductOut, checklistProductOut
// Side Effects: HTTP CRUD /inout, /product-inout

import { xhr, fetchBlob } from "utils";

export const getInouts = (params = "") => xhr.get(`/inout?${params}`);
export const createInout = (data) => xhr.post("/inout", data);
export const updateInout = (data, id) => xhr.put(`/inout/${id}`, data);
export const deleteInout = (id) => xhr.delete(`/inout/${id}`);
export const productInout = (data) => xhr.post("/product-inout", data);
export const revertProductOut = (id) =>
  xhr.put(`/inout/${id}/revert-product-out`);
export const revertProductIn = (id) =>
  xhr.put(`/inout/${id}/revert-product-in`);
export const checklistProductOut = (data, id) =>
  xhr.put(`/inout/${id}/checklist-product-out`, data);

export const exportInouts = async (filtered = []) => {
  const res = await fetchBlob("/inout/export", { query: { filtered } });
  if (res.status === 404) return null;
  if (!res.ok) throw new Error("SERVER_ERROR");
  return res.blob();
};
